import {BoxplotCompareVariant} from '../../types';

export function isCompareTwoClassesValue(value: BoxplotCompareVariant) {
	return value === BoxplotCompareVariant.CompareTwoClasses;
}
